// Compatibility shim (Wave 1 · S2). The generated template-gallery OpenAPI types
// now live in `@heidi/schema/template-gallery`; this re-export keeps existing
// `@/types/global-schema` importers compiling unchanged. Runtime `export *`
// (not type-only) — see src/types/schema.ts. Burned down in Wave 1 · S5.
export * from '@heidi/schema/template-gallery';
